<template>
    <div
        :class="{'user-icon': true, 'active': active && isInteractive}"
        :style="userStyle"
        @mouseleave="active = false"
    >
        <img class="circle" :style="circleStyle" :src="usr.img" @click="active = !active">
        <span class="tooltip">
            <p class="name">{{ isYou ? 'You' : usr.first + ' ' + usr.last }}</p>
            <p v-if="!isYou" class="title">
                <span v-if="usr.title">{{ usr.title }}</span>
                <span v-if="usr.title && usr.org">, </span>
                <span v-if="usr.org">{{ usr.org }}</span>
            </p>
        </span>
        <transition v-if="isInteractive" name="fade" mode="out-in" @before-enter="visible = true" @after-leave="visible = false">
            <UserPopup v-show="active" :usr="usr" :expoId="expoId"/>
        </transition>
    </div>
</template>

<script>
import UserPopup from '../user/UserPopup'

import { auth } from '../../../db'

export default {
    name: 'UserImg',
    props: {
        usr: { required: true },
        interactive: { default: true },
        expoId: { required: true },
        size: { default: '100px' }
    },
    components: {
        UserPopup,
    },
    data() {
        return {
            active: false,
            visible: false,
        }
    },
    computed: {
        isYou() {
            if (auth.currentUser) {
                return auth.currentUser.uid == this.usr.uid
            } else {
                return 'unknown' == this.usr.uid
            }
        },
        isInteractive() {
            return this.interactive && !this.isYou
        },
        userStyle() {
            return {
                zIndex: this.visible ? 100 : 'inherit',
            }
        },
        circleStyle() {
            if (!this.isInteractive) return {
                boxShadow: 'none',
                cursor: 'inherit',
                height: this.size,
                width: this.size
            }
            else return {
                height: this.size,
                width: this.size
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../interface.scss';
.user-icon {
    position: relative;
    .tooltip {
        font-size: 18px;
        white-space: initial;
        text-overflow: initial;
        top: 10px;
        transform: translateY(-50%) translateX(-50%);
        bottom: initial;
        z-index: 60;
        max-width: 300px;
        opacity: 0;
        p {
            display:inline-block;
            width: max-content;
            margin: 0;
            &.name {
                font-weight: bold;
                margin: 3px;
            }
            &.title {
                font-weight: normal;
                font-size: 16px;
                margin-bottom: 2px;
            }
        }
    }
    .circle {
        position: relative;
        cursor: pointer;
        z-index: 50;
        margin: 20px;
        transition: box-shadow 0.2s ease;
        background-color: transparent;
        box-shadow: 0 0 0px 0px transparent;
        &:hover {
            box-shadow: 0 0 0 4px var(--main-color);
            ~ .tooltip {
                opacity: 1;
            }
        }
    }
    &.active {
        .circle {
            box-shadow: 0 0 0 8px var(--main-color);

        }
        .tooltip {
            opacity: 0 !important;
        }
    }
}

</style>